export const ENDPOINTS = {
  histories: (id) => `/organization/${id}/transaction`
};
